<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext">
      <div class="container">
      <tracking-progress :transDataSet="transDate"></tracking-progress>
        <div class="area_wrap wholeWrap">
          <div class="tab_wrap mt-0 coming">
            <ul class="tw_item tabs">
              <li v-for="tab in tabs" :key="tab.tabName" :class="{active: tab  === selectedTab}" @click="onClickTab(tab)">
                {{tab.tabName}}
              </li>
            </ul>
            <div v-if="selectedTab === tabs[0]">
              <div class="label_wrap">
                <div class="lw_item_wrap" @change="etcValue">
                  <div class="lw_item" v-for="(c, i) in getComingList" :key="i + 'A'">
                    <input type="radio" :id="c.id" :value="c.id" :name="c.content" v-model="form.comingReasonCode.value" @click="getReason(i)">
                    <label :for="c.id" class="type">
                      <h3>{{c.content}}</h3>
                    </label>
                  </div>
                  <div class="lw_item">
                    <input type="radio" id="etcFirst" class="etcRadio first" :value="form.hiddenValuePre" @click="choiceEtcReason()" v-model="form.comingReasonCode.value">
                    <label for="etcFirst" class="type">
                      <h3>기타 수술</h3>
                    </label>
                  </div>
                </div>
                <div class="lw_etc pre">
                  <div class="etcInputHeader">
                    <p>기타 수술사유</p>
                    <span class="warn"  v-text="form.etcReason.errorTxt" v-if="form.etcReason.hasError"></span>
                  </div>
                  <label class="reason">
                    <input type="text" class="etc_input" @keyup="blurEtcReason()" placeholder="기타 수술사유를 입력해주세요." ref="etcReason" value="" v-model="form.etcReason.value">
                  </label>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="label_wrap">
                <div class="lw_item_wrap" @change="etcValue2">
                  <div class="lw_item" v-for="(c, i) in getComingList" :key="i + 'B'">
                    <input type="radio" :id="c.id+13" :value="c.id" v-model="form.comingReasonCode.value" @click="getReason(i)">
                    <label :for="c.id+13" class="type">
                      <h3>{{c.content}}</h3>
                    </label>
                  </div>
                  <div class="lw_item">
                    <input type="radio" id="etcReason" class="etcRadio last" @click="choiceEtcReason()" v-model="form.comingReasonCode.value" :value="form.hiddenValuePre">
                    <label for="etcReason" class="type">
                      <h3>기타 검진/검사</h3>
                    </label>
                  </div>
                  <div class="lw_item">
                    <input type="radio" id="etcLast" class="etcRadio last2" @click="choiceEtc()" v-model="form.comingReasonCode.value" :value="form.hiddenValue">
                    <label for="etcLast" class="type">
                      <h3>기타 사유</h3>
                    </label>
                  </div>
                </div>
                <div class="lw_etc pre">
                  <div class="etcInputHeader">
                    <p>기타 검진/검사</p>
                    <span class="warn"  v-text="form.etcReason.errorTxt" v-if="form.etcReason.hasError"></span>
                  </div>
                  <label class="reason">
                    <input type="text" class="etc_input" @keyup="blurEtcReason()" placeholder="기타 검진/검사를 입력해주세요." ref="etcReason" value="" v-model="form.etcReason.value">
                  </label>
                </div>
                <div class="lw_etc last">
                  <div class="etcInputHeader" >
                    <p>기타 사유</p>
                    <span class="warn" v-text="form.etc.errorTxt" v-if="form.etc.hasError"></span>
                  </div>
                  <label class="reason">
                    <input type="text" class="etc_input" @keyup="blurEtc()" placeholder="기타 사유를 입력해주세요." ref="etc" value="" v-model="form.etc.value">
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="btnWrap visible">
            <button type="button" @click="nextDone()">확인</button>
          </div>
        </div>
      </div>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet"/>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import TrackingProgress from '../../components/TrackingProgress'
import AddPopup from '@/components/AddPopup'
import errorParser from '@/utils/error-parser'
import { mapMutations, mapActions, mapGetters, mapState } from 'vuex'
// import { Dert } from '@/assets/js/thanQAlert'
export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single',
        closeType: 'close'
      },
      transDate: {
        headerName: '내원사유',
        progressNum: '50%',
        chapterNum: 2,
        prevUrl: '/reservation/choiceType'
      },
      tabs: [
        { tabName: '수술/시술 상담', code: 'surgery' },
        { tabName: '검진/검사/기타', code: 'checkup' }
      ],
      comingList: [],
      selectedTab: '',
      check: false,
      form: {
        category: {
          value: ''
        },
        comingReasonCategory: {
          value: ''
        },
        comingReasonCode: {
          value: ''
        },
        content: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        },
        etc: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '기타 사유를 입력해주세요.'
        },
        etcReason: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '기타 사유를 입력해주세요.'
        },
        isEtc: false,
        isEtcReason: false,
        hiddenValuePre: 98,
        hiddenValue: 99
      }
    }
  },
  computed: {
    ...mapGetters([
      'getComingList',
      'getTelDataCarry',
      'GET_RESERVATION_INIT_MESSAGE'
    ]),
    ...mapState([
      'checkPopup'
    ])
  },
  created () {
    /* if (this.GET_RESERVATION_INIT_MESSAGE === true) {
        this.SET_POPUP(true)
        this.popupSet.content = '예약이 취소되었습니다.'
        this.$store.commit('SET_RESERVATION_INIT_MESSAGE', false)
      } */
  },
  methods: {
    ...mapMutations([
      'SET_COMING',
      'SET_POPUP',
      'SET_COMING_TELL'
    ]),
    ...mapActions([
      'COMING_LIST'
    ]),
    initEtcValue () {
      this.form.etc.value = ''
      this.form.etcReason.value = ''
    },
    initEtcValueChild () {
      this.form.etc.value = ''
      this.form.etcReason.value = ''
      this.form.isEtc = false
      this.form.isEtcReason = false
    },
    choiceEtc () {
      this.initEtcValue()
      this.form.content.value = ''
      this.form.isEtc = true
      this.form.isEtcReason = false
    },
    choiceEtcReason () {
      this.form.content.value = ''
      this.initEtcValue()
      this.form.isEtcReason = true
      this.form.isEtc = false
    },
    getReason (id) {
      this.form.content.value = this.getComingList[id].content
      console.log('정보', this.getComingList[id])
      console.log('고른 값은?', this.form.content.value)
      this.initEtcValueChild()
    },
    blurEtc () {
      this.form.etc.flag = false
      this.checkEtc()
    },
    blurEtcReason () {
      this.form.etcReason.flag = false
      this.checkEtcReason()
    },
    checkEtc () {
      if (this.form.etc.flag) return true
      const etcInput = document.querySelector('.lw_etc.last')
      const etc = this.form.etc.value.trim()
      if (etcInput.style.display === 'block') {
        this.$refs.etc.focus()
        if (etc === '') {
          console.log('비어서 빈값에 진입함', etcInput)
          this.form.etc.hasError = true
          this.form.etc.flag = false
          this.form.etc.errorTxt = '기타 사유를 입력해주세요.'
          return false
        }
      }
      if (etcInput.style.display === 'none') {
        this.form.etc.hasError = false
        this.form.etc.flag = true
        this.form.etc.errorTxt = ''
      }
      this.form.etc.flag = true
      this.form.etc.hasError = false
      this.form.etc.errorTxt = ''
      return true
    },
    checkEtcReason () {
      if (this.form.etcReason.flag) return true
      const etcInput = document.querySelector('.lw_etc.pre')
      const etcReason = this.form.etcReason.value.trim()
      if (etcInput.style.display === 'block') {
        this.$refs.etcReason.focus()
        if (etcReason === '') {
          this.form.etcReason.hasError = true
          this.form.etcReason.flag = false
          this.form.etcReason.errorTxt = '기타 내원 사유를 입력해주세요.'
          return false
        }
      }
      if (etcInput.style.display === 'none') {
        this.form.etcReason.hasError = false
        this.form.etcReason.flag = true
        this.form.etcReason.errorTxt = ''
      }
      this.form.etcReason.flag = true
      this.form.etcReason.hasError = false
      this.form.etcReason.errorTxt = ''
      return true
    },
    etcValue () {
      const etc1 = document.querySelector('.etcRadio.first')
      const input = etc1.closest('.label_wrap').childNodes[1]
      console.log('input', input) // etc
      console.log('etc1.value', etc1.value)
      console.log('this.form.comingReasonCode.value', this.form.comingReasonCode.value)
      if (this.form.hiddenValuePre === this.form.comingReasonCode.value) {
        input.style.display = 'block'
        this.$refs.etcReason.focus()
      }
      if (this.form.hiddenValuePre !== this.form.comingReasonCode.value) {
        input.style.display = 'none'
      }
    },
    etcValue2 () {
      const etc2 = document.querySelector('.etcRadio.last')
      const inputPre = etc2.closest('.label_wrap').childNodes[1]
      const input = etc2.closest('.label_wrap').childNodes[2]
      console.log('inputPre', inputPre)
      console.log('input', input)
      console.log('etc2.value', etc2.value)
      if (this.form.hiddenValuePre === this.form.comingReasonCode.value) {
        inputPre.style.display = 'block'
        input.style.display = 'none'
        this.$refs.etc.focus()
      } else if ((this.form.hiddenValuePre !== this.form.comingReasonCode.value) && (this.form.comingReasonCode.value !== this.form.hiddenValue)) {
        inputPre.style.display = 'none'
        input.style.display = 'none'
      } else if (this.form.hiddenValue === this.form.comingReasonCode.value) {
        input.style.display = 'block'
        inputPre.style.display = 'none'
        this.$refs.etcReason.focus()
      } else if ((this.form.hiddenValue !== this.form.comingReasonCode.value) && (this.form.comingReasonCode.value !== this.form.hiddenValuePre)) {
        inputPre.style.display = 'none'
        input.style.display = 'none'
      }
    },
    initialize () {
      this.form.comingReasonCode.value = ''
      this.form.content.value = ''
      this.form.isEtc = false
      document.querySelector('.etcRadio').closest('.label_wrap').childNodes[1].style.display = 'none'
      this.initEtcValue()
    },
    onClickTab (tab) {
      this.selectedTab = tab
      this.initialize()
      this.fetchData()
    },
    nextDone () {
      const etc = this.form.etc.value.trim()
      const etcReason = this.form.etcReason.value.trim()
      const etcContents = this.form.etc.value.trim() + this.form.etcReason.value.trim()
      if (this.form.isEtcReason) {
        console.log('현재의 값은? ', etcReason)
        if (etcReason === '') {
          this.SET_POPUP(true)
          this.popupSet.content = '기타 내원사유를 입력해주세요.'
          this.form.etcReason.flag = false
          this.form.etcReason.hasError = true
          return false
        }
        this.$refs.etcReason.focus()
      } if (this.form.isEtc) {
        console.log('현재의 값은? ', etc)
        if (etc === '') {
          this.SET_POPUP(true)
          this.popupSet.content = '기타 사유를 입력해주세요.'
          this.form.etc.flag = false
          this.form.etc.hasError = true
          return false
        }
      }
      if (this.form.comingReasonCode.value === '') {
        this.SET_POPUP(true)
        this.popupSet.content = '내원사유를 선택해주세요.'
        return false
      }
      const comingTell = {
        userName: this.getTelDataCarry.userName,
        tel: this.getTelDataCarry.tel,
        visitPathCode: this.getTelDataCarry.visitPathCode,
        requestContents: this.getTelDataCarry.requestContents,
        comingReasonCategory: this.selectedTab.code,
        comingReasonCode: this.form.comingReasonCode.value,
        etc: this.form.isEtc,
        etcReason: this.form.isEtcReason,
        etcContents: etcContents,
        content: this.form.content.value
      }
      this.SET_COMING_TELL(comingTell)
      console.log('저장한 커밍은', comingTell)
      this.$router.push('/telReservation_step2')
    },
    async comingListAct () {
      const category = this.selectedTab.code
      try {
        await this.COMING_LIST(category)
      } catch (error) {
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      }
    },
    fetchData () {
      this.comingListAct()
    }
  },
  mounted () {
    this.selectedTab = this.tabs[0]
    this.fetchData()
  },
  components: {
    AppHeader,
    AppSidebar,
    TrackingProgress,
    AddPopup
  },
  beforeDestroy () {
    this.SET_POPUP(false)
  }
}
</script>

<style lang="scss" scoped>
  .trackingProgress {
    top: 0;
  }
</style>
